/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import TransmissionDetailChart from "../../components/Charts/TransmissionDetailsChart";
import Table from "../../components/form/Table";
import { getMeterUsageReportApi } from "../../Services/reports";
import {useNavigate, useParams} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_IS_API_CALLED,
  SET_IS_API_CALLED_FINISHED,
} from "../../store/features/loadingSlice";
import dayjs from "dayjs";
import DateRange from "../../components/form/DateRange";
import TextInput from "../../components/form/TextInput";
import { debounce } from "../../utils/debounce";
import { Link } from "react-router-dom/dist";
import DropdownInput from "../../components/form/DropdownInput";
import { useDropdowns } from "../../hooks/useDropdowns";
import {ExcelFileGeneratorUtil} from "../../utils/ExcelUtils/ExcelFileGeneratorUtil";
import {getMeterUsageReportExcelDownload} from "../../Services/reports";
import { DateUtils } from "../../utils/dateUtils";

const headers = [
  { key: "no", th: "No." },
  { key: "actualReadingDate", th: "Actual Reading Date" },
  { key: "serialNumber", th: "Meter ID" },
  { key: "reverseMeasurement", th: "Reverse Measurement" },
  { key: "forwardMeasurement", th: "Forward Measurement" },
  { key: "netMeasurement", th: "Net Measurement" },
  { key: "reverse", th: "Reverse" },
  { key: "forward", th: "Forward" },
  { key: "net", th: "Net" },
  { key: "flowRate", th: "Flow Rate" },
  { key: "velocity", th: "Velocity" },
  { key: "displayDate", th: "Display Date" },
];

function ActivePremiseMeterDetail() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { id } = useParams();
  const { isModel } = useSelector((state) => state.Loading);
  const { state, getIntervalDropDown } = useDropdowns();
  const [viewTable, setViewTable] = useState(false);
  const [meterUsageData, setMeterUsageData] = useState(null);

  const start = dayjs(new Date(new Date().setMonth(new Date().getMonth() - 1)));
  const end = dayjs(new Date());

  const [filterParams, setFilterParams] = useState({
    pageSize: 8,
    serialNumber: id,
    intervalTypeId: 3,
    date: [start, end],
    startDate: dayjs(start).format("YYYY-MM-DDTHH:mm:ss"),
    endDate: dayjs(end).format("YYYY-MM-DDTHH:mm:ss"),
  });

  const handleDateChange = (date) => {
    setFilterParams(prev => ({
      ...prev,
      date,
      startDate: dayjs(date[0]).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: dayjs(date[1]).format("YYYY-MM-DDTHH:mm:ss"),
      pageIndex: 1,
    }));
  };

  const LoadData = async () => {
    dispatch(SET_IS_API_CALLED("Fetching Data"));
    window.history.replaceState(
      null,
      "Air Selangor",
      "/active-premise-meter/" + filterParams?.serialNumber
    );

    const res = await getMeterUsageReportApi({
      ...filterParams,
      serialNumber: filterParams?.serialNumber,
      pageSize: 10,
      pageIndex: meterUsageData?.pageIndex,
    })
    
    setMeterUsageData(res?.data);

    dispatch(SET_IS_API_CALLED_FINISHED());
  };

  useEffect(() => {
    getIntervalDropDown();
    setTimeout(() => {
      LoadData();
    }, 500);
  }, []);

  useEffect(() => {
    LoadData();
  }, [filterParams]);

  const exportDataToExcelFile = async () => {
    dispatch(SET_IS_API_CALLED("Exporting Excel"));

    const res = await getMeterUsageReportExcelDownload(filterParams)
    const data = res?.data?.map((item) => ({
      ...item,
      actualReadingDate: item.actualReadingDate ? dayjs(item.actualReadingDate).format("DD/MM/YYYY h:mm:ss a") : "N/A",
    }))

    ExcelFileGeneratorUtil({
      filename: `active-premise-meter-${id}.xlsx`,
      formattedDataForExcelFile: data,
    });

    dispatch(SET_IS_API_CALLED_FINISHED());
  };

  const debouncedOnFilter = debounce((val) => {
    setFilterParams({
      ...filterParams,
      serialNumber: val,
      pageIndex: 1,
    });
  }, 500);

  const replacementHistory = meterUsageData?.deviceReplacementAuditTrail ?? [];

  return (
    <div>
      <div className=" flex gap-4 items-center">
        <Link to={"/active-premise-meter"}>
          <div className=" my-4 cursor-pointer">
            <div className=" flex justify-center items-center gap-5 bg-dark-blue-200 hover:bg-blue-600 text-white w-[170px] h-[45px] font-bold text-lg ">
              <img
                src="/assets/Icon%20ionic-ios-arrow-back.svg"
                width={6}
                height={11}
                alt="Plus"
              />
              <span>Back</span>
            </div>
          </div>
        </Link>
        <div className=" w-[240px]">
          <DropdownInput
            selectedOption={filterParams?.intervalTypeId}
            selectCaption={"Device Type"}
            value={"id"}
            label={"name"}
            onChange={(val) => {
              setFilterParams({
                ...filterParams,
                intervalTypeId: val,
                pageIndex: 1,
              });
            }}
            items={state?.intervalTypesDropDown}
          />
        </div>
        <div className="flex items-center gap-3 justify-start ">
          <TextInput
            value={filterParams?.serialNumber}
            onChange={debouncedOnFilter}
            placeholder={"XXXXXXXXXXXX"}
          />
          <div
            onClick={() => {
              LoadData();
            }}
          >
            <img src="/assets/search-alt-1-svgrepo-com.svg" alt="Search" />
          </div>
        </div>
      </div>
      <div className=" flex justify-between w-full flex-wrap items-center mt-3">
        <div className=" flex items-center gap-10 text-dark-blue-200 my-2">
          <div className="">
            <div className=" w-fit gap-2 flex items-center justify-between">
              <h1 className=" text-lg font-bold">
                Meter SN : <span className=" font-normal text-end">{id}</span>{" "}
              </h1>
              <Link
                to={`/alarm-error-management/daily-usage/${
                  filterParams?.serialNumber
                }?start=${filterParams.startDate}&end=${filterParams.endDate}`}
                className=" cursor-pointer"
              >
                <img
                  src="/assets/Icon%20feather-info.svg"
                  className=" w-[24px] h-[24px]"
                  alt=""
                />
              </Link>
            </div>
          </div>
          <div className="">
            <div className="text-lg font-bold flex justify-end gap-2">
              <h1 className=" text-end">Model </h1>
              <span className=" font-normal">
                {meterUsageData?.modelNumber || "N/A"}
              </span>
            </div>
            <div>
              <div className="text-lg font-bold flex justify-end gap-2">
                <h1 className=" text-end">Manufacturer </h1>
                <span className=" font-normal">
                  {meterUsageData?.manufacturer || "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div className="">
            <div>
              <h1 className=" text-lg font-bold">
                Size{" "}
                <span className=" font-normal">
                  {meterUsageData?.size || "N/A"}
                </span>{" "}
              </h1>
            </div>
          </div>
          <div className="">
            <div className="text-lg font-bold flex gap-2">
              <h1 className=" text-end">Installation Date </h1>
              <span className=" font-normal">
                {meterUsageData?.installationDate || "N/A"}
              </span>
            </div>
          </div>
          <div
            className=""
            onClick={() => {
              setViewTable(!viewTable);
            }}
          >
            <div
              className={` ${
                viewTable && " bg-dark-blue-200 "
              } border border-dark-blue-200  w-[49px] h-[40px] flex justify-center rounded-2xl cursor-pointer items-center`}
            >
              <img
                src="/assets/table-list-svgrepo-com.svg"
                className={`w-[24px] h-[24px] ${
                  viewTable && " brightness-[500] "
                } `}
                alt=""
              />
            </div>
          </div>
          <div className="">
            <DateRange
              value={filterParams.date}
              onChange={(date) => handleDateChange(date)}
            />
          </div>
        </div>
        <div className="flex  gap-2 my-2">
          <div className="py-1">
            <img
              src={"/assets/icon-excel.svg"}
              className=" cursor-pointer"
              onClick={() => {
                exportDataToExcelFile()
              }}
              width={35}
              height={35}
              alt=""
            />
          </div>
          <div className="bg-light-grey-200 hover:bg-dark-blue-200 h-[43px] w-[153px] text-lg font-normal flex justify-center items-center cursor-pointer rounded text-white">
            <div onClick={()=> {
              navigate(
                  `/wf-create-case`
              );
            }}>Create Case</div>
          </div>
          <div className="bg-light-grey-200 hover:bg-dark-blue-200 h-[43px] w-[191px] text-lg font-normal flex justify-center items-center cursor-pointer rounded text-white">
            <div onClick={()=> {
              navigate(
                  `/wf-create-case/1`
              );
            }}>Forward to Case</div>
          </div>
        </div>
      </div>
      <div className=" w-full grid grid-cols-12 bg-white pb-3 border border-light-grey-500 my-5 ">
        {viewTable ? (
          <>
            <div className=" col-span-6">
              <div className=" overflow-x-auto">
                {meterUsageData && !isModel && (
                  <TransmissionDetailChart
                    graphData={meterUsageData?.graphData}
                    serialNumber={filterParams?.serialNumber}
                  />
                )}
              </div>
            </div>
            <div className=" col-span-6 px-5">
              <div className=" overflow-x-auto border mt-4 max-h-[550px] overflow-y-auto">
                <Table
                  data={meterUsageData?.graphData.map((val, index) => {
                    return {
                      no: index + 1,
                      actualReadingDate: dayjs(val?.actualReadingDate).format("DD/MM/YYYY h:mm:ss a"),
                      serialNumber: val?.serialNumber,
                      reverseMeasurement: val?.reverseMeasurement,
                      forwardMeasurement: val?.forwardMeasurement,
                      netMeasurement: val?.netMeasurement,
                      reverse: val?.reverse,
                      forward: val?.forward,
                      net: val?.net,
                      flowRate: val?.flowRate,
                      velocity: val?.velocity,
                      displayDate: val?.displayDate,
                    };
                  })}
                  headers={headers}
                  filter={false}
                  order={true}
                  setFilterParams={setFilterParams}
                  filterParams={filterParams}
                />
              </div>
            </div>
          </>
        ) : (
          <div className=" col-span-12 w-full">
            <div className=" overflow-x-auto overflow-y-hidden">
              {meterUsageData && !isModel && (
                <TransmissionDetailChart
                  graphData={meterUsageData?.graphData}
                  serialNumber={filterParams?.serialNumber}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className=" grid gap-4 grid-cols-8 px-4">
        <div className=" col-span-6">
          <div className=" text-lg font-bold leading-normal text-dark-blue-100">
            Premise
          </div>
          <div className=" text-lg font-normal text-dark-grey leading-none ">
            {meterUsageData?.premise || "N/A"}
          </div>
        </div>
      </div>
      <div className=" grid mt-4 grid-cols-8 my-5 px-4">
        <div className=" text-lg font-bold leading-normal col-span-full text-dark-blue-100">
          Device
        </div>

        <div className=" text-lg font-normal text-dark-grey leading-none  col-span-3">
          <div className=" font-bold">Logger</div>
          <div className=" mt-2 font-normal">
            {meterUsageData?.logger || "N/A"}{" "}
          </div>
        </div>
        <div className=" text-lg font-normal text-dark-grey leading-none  col-span-3">
          <div className=" font-bold">Simcard</div>
          <div className=" mt-2 font-normal">
            {meterUsageData?.simCard || "N/A"}
          </div>
        </div>
        <div className=" text-lg font-normal text-dark-grey leading-none  col-span-3 mt-8">
          <div className=" font-bold">Billing Configuration</div>
          <div className=" mt-2 font-normal">
            Totalizer : {meterUsageData?.billingConfiguration || "N/A"}
          </div>
          <div className=" mt-2 font-normal">
            HES : {meterUsageData?.hec || "N/A"}
          </div>
        </div>
      </div>
      <div className="my-5 px-4">
        <div className="text-lg font-bold leading-normal text-dark-blue-100">
          Replacement History
        </div>
        <div className="mt-3 w-full max-w-4xl border border-light-grey-500 bg-white">
          <table className="w-full table-fixed">
            <thead className="border-b bg-white text-dark-blue-200">
              <tr className="text-center">
                <th className="px-2 py-2 text-xs font-medium align-middle border-r border-light-grey-500" colSpan={3}>
                  Old
                </th>
                <th className="px-2 py-2 text-xs font-medium align-middle" colSpan={3}>
                  New
                </th>
              </tr>
              <tr className="border-t text-center">
                <th className="px-2 py-1.5 text-[11px] font-medium">Serial Number</th>
                <th className="px-2 py-1.5 text-[11px] font-medium">Model</th>
                <th className="px-2 py-1.5 text-[11px] font-medium border-r border-light-grey-500">Installation Date</th>
                <th className="px-2 py-1.5 text-[11px] font-medium">Serial Number</th>
                <th className="px-2 py-1.5 text-[11px] font-medium">Model</th>
                <th className="px-2 py-1.5 text-[11px] font-medium">Installation Date</th>
              </tr>
            </thead>
            <tbody>
              {replacementHistory.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-2 py-5 text-center text-xs text-light-grey-400">
                    No Data
                  </td>
                </tr>
              ) : (
                replacementHistory.map((row, index) => (
                  <tr
                    key={`replacement-${index}`}
                    className={`border-b ${
                      index % 2 === 1 ? "bg-white" : "bg-light-grey-100"
                    } text-center text-medium-grey`}
                  >
                    <td className="px-2 py-2.5 text-[11px]">
                      {row?.oldSerialNumber || "N/A"}
                    </td>
                    <td className="px-2 py-2.5 text-[11px]">
                      {row?.oldModel || "N/A"}
                    </td>
                    <td className="px-2 py-2.5 text-[11px] border-r border-light-grey-500">
                      {DateUtils.parseDateWithPeriod(row?.oldInstallationDate) || "N/A"}
                    </td>
                    <td className="px-2 py-2.5 text-[11px]">
                      {row?.newSerialNumber || "N/A"}
                    </td>
                    <td className="px-2 py-2.5 text-[11px]">
                      {row?.newModel || "N/A"}
                    </td>
                    <td className="px-2 py-2.5 text-[11px]">
                      {DateUtils.parseDateWithPeriod(row?.newInstallationDate) || "N/A"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ActivePremiseMeterDetail;
